'use strict';

module.exports = {
    trainData: /*@ngInject*/  ["TripService", "$stateParams", "$q", "$state", function (TripService, $stateParams, $q, $state) {
        var deferred = $q.defer();
        TripService.getTripById($stateParams.projectId, $stateParams.tripId, function (data) {
            deferred.resolve(
                {
                    "relativeTrainId": data.trainId,
                    "from": data.departure,
                    "to": data.arrival,
                    "projectId": data.projectId,
                    "projectName": data.projectName,
                    "isTrip": true,
                    "tripId": data.id,
                    "trajectory": data.trajectory,
                    "statistics": data.statistics,
                    "officialId": data.officialId,
                    'trainName': data.trainName

                }
            );
        });
        return deferred.promise;
    }],
    boxDiscriminationInfo: /*@ngInject*/  ["ConfigurationResourceService", "$q", "$stateParams", function (ConfigurationResourceService, $q, $stateParams) {
        return resolveDiscriminatorsForTrip(ConfigurationResourceService, $stateParams.tripId, $stateParams.projectId, $q);
    }],
    coachDiscriminationInfo: /*@ngInject*/  ["ConfigurationResourceService", "$q", "$stateParams", function (ConfigurationResourceService, $q, $stateParams) {
        return resolveCoachDiscriminatorForTrip(ConfigurationResourceService, $stateParams.tripId, $stateParams.projectId, $q);
    }],
    obisDiscriminationInfo: /*@ngInject*/  ["ConfigurationResourceService", "$q", "$stateParams","ProjectService", function (ConfigurationResourceService, $q, $stateParams, ProjectService) {
        return new Promise((resolve, reject) => {
            ConfigurationResourceService.noc().get({
                projectId: ProjectService.getSelectedProjectId()
            }).$promise.then(function(result){
                var data = result && result.data;
                var obisEnabled = (data && data.dashboardConfiguration) ? (data.dashboardConfiguration.dashboardHideObis === undefined ? false : !data.dashboardConfiguration.dashboardHideObis) : false;
                if(obisEnabled) {
                    resolve(resolveObisDiscriminatorForTrip(ConfigurationResourceService, $stateParams.tripId, $stateParams.projectId, $q));
                } else {
                    resolve(null);
                }
            });
        }) 
    }]
};

function resolveDiscriminatorsForTrip(ConfigurationResourceService, tripId, projectId, $q) {
    var deferred = $q.defer();
    ConfigurationResourceService.getBoxDiscriptorsForTrip({
        'tripId': tripId,
        'projectId': projectId
    }, function (data) {
        deferred.resolve(data);
    }, () => {
        $state.go('trip.search', {
            'projectId': projectId
        })
    });
    return deferred.promise;
}

function resolveCoachDiscriminatorForTrip(ConfigurationResourceService, tripId, projectId, $q) {
    var deferred = $q.defer();
    ConfigurationResourceService.getTripCoachDiscriptors({
        'tripId': tripId,
        'projectId': projectId
    }, function (data) {
        deferred.resolve(data);
    });
    return deferred.promise;
}

function resolveObisDiscriminatorForTrip(ConfigurationResourceService, tripId, projectId, $q) {
    var deferred = $q.defer();
    ConfigurationResourceService.getObisDiscriptorsForTrip({
        'tripId': tripId,
        'projectId': projectId
    }, function (data) {
        console.log("OBIS:", data)
        deferred.resolve(data);
    });
    return deferred.promise;
}